import { createContext, useContext, useState, useEffect } from "react";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [base, setBase] = useState(() => localStorage.getItem("finakis_base") || "TRY");

  useEffect(() => {
    localStorage.setItem("finakis_base", base);
  }, [base]);

  return (
    <CurrencyContext.Provider value={{ base, setBase }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
